import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { ApplicationStatusCard } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/ApplicationStatus/ApplicationStatusCard";
import { ApplicationStatusText } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/ApplicationStatus/ApplicationStatusText";
import {
  FAInnerWrapperRow,
  FAOuterWrapper,
} from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { Decorative } from "@faire/design-tokens";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { GrowingSpacer } from "@faire/web/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import React from "react";

export const ApplicationStatus: React.FC = () => {
  const { pageState, isLoggedInNewApplied } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.APPLICATION_STATUS
    )
  );

  if (!isLoggedInNewApplied) {
    return null;
  }

  return (
    <FAOuterWrapper $bgColor={Decorative.tint.neutral} ref={ref}>
      <FAInnerWrapperRow>
        <ApplicationStatusText />
        <GrowingSpacer base="3x" />
        <ApplicationStatusCard />
      </FAInnerWrapperRow>
    </FAOuterWrapper>
  );
};
